import React, { useState, useRef, useEffect } from "react";
import { Col } from "react-bootstrap";
import DatePicker from "../DatePicker/datepicker";
import SignInInput from "../SigninInput/signinInput";
import { format, addYears } from "date-fns";
import styles from "../../component/onboarding/onboard.module.css";
import datePickerIcon from "../../component/signup/assets/datePickerIcon.svg";

const DateInputWithCalendar = ({
  label,
  placeholder,
  name,
  value,
  onHandleDate,
  disabled = false,
  mindate,
  isInvalid,
  errorMessage,
}) => {
  var currentDate = new Date();
  const calendarRef = useRef(null);
  const iconRef = useRef(null);
  const [showCalendar, setShowCalender] = useState(false);

  const formatDateDisplay = (date) => {
    if (typeof date === "string") {
      return date;
    }
    return format(date, "dd-MM-yyyy");
  };

  const toggleCalender = () => {
    setShowCalender(!showCalendar);
  };

  const parseDOB = (dobString) => {
    if (!dobString) {
      return null;
    }

    const parts = dobString.split("/");
    if (parts.length !== 3) {
      return null;
    }

    const [day, month, year] = parts;
    return new Date(`${year}-${month}-${day}`);
  };

  const handleClickOutside = (event) => {
    if (calendarRef.current && !calendarRef.current.contains(event.target)) {
      setShowCalender(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        calendarRef.current &&
        !calendarRef.current.contains(event.target) &&
        iconRef.current &&
        !iconRef.current.contains(event.target)
      ) {
        setShowCalender(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Col md={4} style={{ position: "relative" }}>
      <div onClick={toggleCalender}>
        <SignInInput
          containerClasses={styles.passwordInvalid}
          tabIndex="6"
          label={label}
          placeholder={placeholder}
          type="text"
          name={name}
          value={formatDateDisplay(value)}
          readOnly={true}
          disabled={disabled}
          isInvalid={isInvalid}
          errorMessage={errorMessage}
        />
      </div>
      {disabled === false && showCalendar && (
        <div ref={calendarRef} className={styles.calendertop}>
          <DatePicker
            onChange={(date) => {
              onHandleDate(date);
              const formatedDate = formatDateDisplay(date);
              const event = {
                target: {
                  name: name,
                  value: formatedDate,
                },
              };
              setShowCalender(false);
            }}
            maxDate={
              name === "passportExpiryDate"
                ? addYears(new Date(), 20)
                : new Date()
            }
            minDate={
              name === "passportIssueDate"
                ? addYears(parseDOB(mindate), 0)
                : name === "passportExpiryDate"
                ? (currentDate = new Date(
                    currentDate.getTime() + 24 * 60 * 60 * 1000
                  ))
                : addYears(new Date(), -80)
            }
            date={new Date()}
            color="#0061D3"
          />
        </div>
      )}
      {
        <img
        ref={iconRef}
          style={{ height: "18px", width: "18px" }}
          alt=""
          className={styles.calendericon}
          src={datePickerIcon}
          onClick={() => {
            setShowCalender(!showCalendar);
          }}
        />
      }
    </Col>
  );
};

export default DateInputWithCalendar;
